import { ImageOff, LoaderCircle } from "lucide-react";
import useRenderingImages from "../../hooks/useRenderingImages";
import RenderingGrid from "./RenderingGrid";

export default function ConceptualRenderingsGallery({ renderings }) {
  const { imageUrls, state } = useRenderingImages(renderings);

  return (
    <section className="renderings-gallery" data-testid="investor-renderings-gallery">
      <div className="library-title">
        <div>
          <span className="eyebrow">Confidential visual materials</span>
          <h2>CONCEPTUAL RENDERINGS</h2>
        </div>
        <span className="watermark" data-testid="renderings-watermark">Conceptual renderings for confidential discussion purposes only.</span>
      </div>
      {!renderings.length && <div className="empty-state" data-testid="renderings-empty-state"><ImageOff size={20} />No conceptual renderings have been published yet.</div>}
      {state === "loading" && <div className="loading-state" data-testid="renderings-loading-state"><LoaderCircle className="spin" size={20} />Loading confidential renderings…</div>}
      {state === "error" && <div className="empty-state" data-testid="renderings-error-state">Renderings are temporarily unavailable.</div>}
      {state === "ready" && renderings.length > 0 && <RenderingGrid imageUrls={imageUrls} renderings={renderings} />}
    </section>
  );
}